import { render, staticRenderFns } from "./LiveChatButton.vue?vue&type=template&id=80515b5e&scoped=true&"
import script from "./LiveChatButton.vue?vue&type=script&lang=js&"
export * from "./LiveChatButton.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatButton.vue?vue&type=style&index=0&id=80515b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80515b5e",
  null
  
)

export default component.exports